import { AUTOSHIP_CONST as COMMON_AUTOSHIP_CONST } from '@libs/common-types';

const scene7StaticBase = process.env.NEXT_PUBLIC_SCENE7_STATIC_BASE;

export const SCENE7_BASE_URLS = {
    IMAGE: scene7StaticBase,
    VIDEO: 'https://s7d2.scene7.com/is/content/PetSmart',
};

export const PICTURES = {
    NOT_FOUND: {
        ALT_TEXT: '404 Dog',
        SRC: `${scene7StaticBase}WEB-2371948-Aug24_404Page_Replatform_DT`,
    },
};

export const SUPPORT_PHONE_NUMBER = {
    FORMATTED: '1 (888) 839-9638',
    RAW: '18888399638',
};

export const STORE_NUMBER = {
    STERLING_VA: 453,
    NIAGARA_FALLS: 2234,
};

export const VELOCITY_STORE_DELETED_ATTEMPT_FIX_NUM = 6;

export const PROFILE_DATA = {
    PROFILE: 'profile',
    ADDRESSES: 'addresses',
    PAYMENTS: 'payments',
    APPOINTMENTS: 'appointments',
    PACKAGES: 'packages',
};

/**
 * @deprecated This constant is deprecated and should be removed as part of SB-2076.
 */
export const AUTOSHIP_CONST = COMMON_AUTOSHIP_CONST;

export enum CountryTarget {
    US = 'US',
    CA = 'CA',
    BOTH = 'BOTH',
}
